import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {devConsolelog} from '../../Utility';
import commonStyles from '../AgentWebsite/commonStyles';
import {StyledButton} from './styledTabs';
import { makeStyles,useTheme } from "@material-ui/core/styles";

export default function ResponsiveDialog({titleText="", bodyText="", actions=[], openDailog=false, onClose, fullScreen=null, maxWidth='sm', disableBackdropClick= false, showDropdown= false, titleClass= {}}) {
  const [open, setOpen] = React.useState(openDailog);
  const theme = useTheme();
  const commonClasses = commonStyles();
  const mobileFullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  if(fullScreen === null) fullScreen = mobileFullScreen;

  function handleClose() {
    setOpen(false);
  }

  const useStyles = makeStyles({
    paperFullWidth: {
      overflowY: 'visible',
      backgroundColor:theme?.agentTheme?.card?.main
    },
    dialogContentRoot: {
      overflowY: 'visible',
    },
    dialogContentRootMweb: {
      overflowY: 'auto',
    },
    titleDefaultClass: {
      color: '#212121',
    }
  });

  devConsolelog('DailogModal ', openDailog, open, titleText, actions, mobileFullScreen, fullScreen);
  const classes = useStyles();
  return (
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        open={open}
        onClose={onClose || handleClose}
        maxWidth={maxWidth}
        classes={{
          paperFullWidth: showDropdown && classes.paperFullWidth
        }}
        aria-labelledby="responsive-dialog-title"
        disableBackdropClick={disableBackdropClick}
      >
        <DialogTitle id="responsive-dialog-title" className={`${titleClass ? titleClass : {}} ${classes.titleDefaultClass}`} >{titleText}</DialogTitle>
        <DialogContent style={{backgroundColor:theme?.agentTheme?.card?.main}} classes={{
          root: showDropdown && (mobileFullScreen ? classes.dialogContentRootMweb : classes.dialogContentRoot)
        }}>
          {bodyText}
        </DialogContent>
        <DialogActions>
          {
            actions.map((action) => {
              if(action.hide == true) return null;
              else return (<StyledButton {...action.props} fullWidth href={action.href || null} className={action.className} onClick={action.onClick || handleClose} >
                <Typography  className={commonClasses.buttonText}>{action.name}</Typography>
              </StyledButton>)
            })
          }
        </DialogActions>
      </Dialog>
  );
}
